import React from 'react';
import { useTranslation } from 'react-i18next';

function Poles() {
  const { t } = useTranslation();

  const poles = [
    { id: 'geomatics', title: t('poles.geomatics.title'), items: t('poles.geomatics.items', { returnObjects: true }) },
    { id: 'nfciot', title: t('poles.nfciot.title'), items: t('poles.nfciot.items', { returnObjects: true }) },
    { id: 'print3d', title: t('poles.print3d.title'), items: t('poles.print3d.items', { returnObjects: true }) },
    { id: 'nfccards', title: t('poles.nfccards.title'), items: t('poles.nfccards.items', { returnObjects: true }) },
  ];

  const whatsappQuoteUrl = `https://wa.me/221785949274?text=${encodeURIComponent(t('whatsapp.quoteMessage'))}`;

  return (
    <section className="services-section" id="poles">
      <h3>{t('poles.title')}</h3>
      <p className="services-intro">{t('poles.intro')}</p>
      <div className="services-grid">
        {poles.map((pole) => (
          <div key={pole.id} className="service-card">
            <h4>{pole.title}</h4>
            <ul>
              {pole.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="services-cta">
        <a
          className="cta-button whatsapp"
          href={whatsappQuoteUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('poles.cta')}
        </a>
      </div>
    </section>
  );
}

export default Poles;
